if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector(".swiper");
      this.slides = this.querySelectorAll(".swiper-slide");
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.nextSlideButton = this.querySelector(".custom-button-next");
      this.prevSlideButton = this.querySelector(".custom-button-prev");
      this.activeIndex = 0;
      this.initialized = false;
      this.fraction = this.querySelector("[data-swiper-fraction]") || false;
      this.activeIndex = 0;
      this.slidesCount = this.slides?.length;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('[data-swiper-thumbs]');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slidesCount > 0) {
        if (document.readyState === 'complete') {
          this.initializeSwiper()
        } else {
          document.addEventListener(
            "DOMContentLoaded",
            this.initializeSwiper.bind(this)
          );
        }
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));
        this.addEventListener("update-slides", this.updateSlides.bind(this));
        this.addEventListener("refresh", this.refresh.bind(this));
        this.addEventListener("go-to-slide", this.goToSlide.bind(this));
        if (this.nextSlideButton) {
          this.nextSlideButton.addEventListener(
            "click",
            this.nextSlide.bind(this)
          );
        }
        if (this.prevSlideButton) {
          this.prevSlideButton.addEventListener(
            "click",
            this.prevSlide.bind(this)
          );
        }
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }
    nextSlide() {
      this.slider.slideNext();
    }
    prevSlide() {
      this.slider.slidePrev();
    }

    updateSlides(evt) {
      this.slider.appendSlide(evt.detail.slides);
      this.goToSlide(evt);
      this.slider.update();
    }

    refresh(evt) {
      this.slider.update();
    }

    goToSlide(evt) {
      let index = evt.detail.index;
      if (!index && evt.detail.position) {
        const elm = this.querySelector(
          "[data-position='" + evt.detail.position + "']"
        );
        index = [...elm.parentNode.children].indexOf(elm);
      }
      if (index != 0 && !index) return;
      this.slider.slideTo(index);
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        let options = JSON.parse(this.dataset.swiperOptions);
        let bullets = this.dataset.swiperBullets;
        if (bullets) {
          bullets = bullets.split(",");
          options.pagination.renderBullet = function (index, className) {
            return (
              '<p class="swiper-pagination-bullet--text ' +
              className +
              '">' +
              bullets[index] +
              "</p>"
            );
          };
        }
        return options;
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        if(this.fraction) {
          const fraction = this.fraction;
          const slidesCount = this.slidesCount;
          this.sliderOptions.on = {
            slideChange: function () {
              let position = this.activeIndex;
              if(position == 0) {
                position = slidesCount;
              } else if(position > slidesCount) {
                position = position - slidesCount;
              }
              fraction.textContent = `${position} / ${slidesCount}`;
            }
          }
        }
        const activeSlideIndex = [...this.slides].findIndex(slide => slide.classList.contains('swiper-slide-active'));
        if (activeSlideIndex > 0) {
          this.sliderOptions.initialSlide = activeSlideIndex;
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = {swiper: thumbnailsSlider};
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener("swiper_event", this.updateSlides.bind(this));
          break;
      }
    }


    initializeSliderEventListeners() {
      if (this.slider) {
        this.slider.on('slideChange', () => {
          const activeSlide = this.slider.slides[this.slider.activeIndex];
          const event = new CustomEvent('slide-changed', {
            bubbles: true,
            detail: { 
              activeSlide: activeSlide || null,
              sliderId: this.id || null
            }
          });
          this.dispatchEvent(event);
        });
      }
    }
  }
  customElements.define("swiper-slider", SwiperSlider);






  class SwiperTabSlider extends SwiperSlider {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".glide__nav-item");
      if (this.tabs.length > 0) {
        this.tabs.forEach((tab) => {
          tab.addEventListener("click", this.goToSlide.bind(this, tab));
        });
      }
    }
    goToSlide(tab) {
      try {
        const tabIndex = tab.dataset.newIndex;
        if (tabIndex) {
          this.slider.slideTo(tabIndex);
        } else {
          console.warn("newIndex not provided for Tab Slider Tab");
        }
      } catch (err) {
        console.warn(err);
      }
    }
  }

  customElements.define("swiper-tab-slider", SwiperTabSlider);
}
